import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HotelDetailsService {

  readonly promoAwardRegex = /promo:workforceAward/;

  awardWinner(tags: string[] = []): boolean {
    return tags.some(tag => this.promoAwardRegex.test(tag));
  }
}
